module.exports = __webpack_public_path__ + "static/media/speakout.2a0ee807.png";